export default function () {
    return class CustomMarkerClass extends google.maps.OverlayView {
        constructor(latlng, map, imageSrc, marges) {
            super();
            this.latlng_ = latlng;
            this.imageSrc = imageSrc;
            this.marges = marges;
            // Once the LatLng and text are set, add the overlay to the map.  This will
            // trigger a call to panes_changed which should in turn call draw.
            this.setMap(window.map);
            return this;
        }
        draw() {
            // Check if the div has been created.
            var div = this.div_;
            if (!div) {
                // Create a overlay text DIV
                div = this.div_ = document.createElement('div');
                // Create the DIV representing our CustomMarker
                div.className = "customMarker";
                div.style = "text-align:center;";
                div.style.zIndex = 1000;
                var img = document.createElement("i");
                img.className = "fa fa-" + this.imageSrc;
                img.style = "color: white;font-size:" + this.marges.size + "px;margin-top:" + this.marges.margin + "px;";
                div.appendChild(img);
                var me = this;
                // Then add the overlay to the DOM
                var panes = this.getPanes();
                panes.overlayMouseTarget.appendChild(div);
                google.maps.event.addDomListener(div, 'click', function () {
                    google.maps.event.trigger(me, 'click');
                });
            }
            // Position the overlay 
            var point = this.getProjection().fromLatLngToDivPixel(this.latlng_);
            if (point) {
                div.style.left = point.x + 'px';
                div.style.top = point.y + 'px';
            }
        }
        ;
        remove() {
            // Check if the overlay was on the map and needs to be removed.
            if (this.div_) {
                this.div_.parentNode.removeChild(this.div_);
                this.div_ = null;
            }
        }
        ;
        getPosition() {
            return this.latlng_;
        }
        ;
    };
}
//# sourceMappingURL=CustomMarkerClass.js.map